import axios from 'axios';

import { getLastSeenProductIdsStorage } from '@jsmdg/browser-storage';
import { createFragment } from '@jsmdg/react-fragment-scripts/fragment';
import { Brand, Tenant } from '@jsmdg/tenancy';
import { type FragmentContext } from '../shared/types';
import { Recommendations } from './components/Recommendations';
import { fetchProducts } from './services/fetchProducts';

// eslint-disable-next-line @typescript-eslint/require-await
async function initDependencies({ baseUrl }: { baseUrl?: string }): Promise<void> {
    axios.defaults.baseURL = baseUrl;
}

const { Fragment, init } = createFragment(
    Recommendations,
    ({
        tenant,
        locale,
        rootComponentProps: {
            initialWishlist,
            customerState,
            wishlistEnabled,
            pageType,
            tenantConfig,
            locationFilter,
            featureFlagsVariation,
            dyRecommendations,
        },
    }): FragmentContext => ({
        locale,
        tenant,
        getLastSeenProductIdsStorage,
        customerState,
        initialWishlist,
        wishlistEnabled,
        locationFilter,
        pageType,
        tenantConfig,
        isMydays: new Tenant(tenant).belongsTo(Brand.Mydays),
        featureFlagsVariation,
        dyRecommendations,
        fetchProducts,
    }),
    initDependencies,
);

export { Fragment, init };
